export default "__VITE_ASSET__2XWPW51d__"